import { render } from "./AvisoDePrivacidad.vue?vue&type=template&id=4497e5ba&scoped=true"
import script from "./AvisoDePrivacidad.vue?vue&type=script&lang=js"
export * from "./AvisoDePrivacidad.vue?vue&type=script&lang=js"

import "./AvisoDePrivacidad.vue?vue&type=style&index=0&id=4497e5ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4497e5ba"]])

export default __exports__